// La nota operativa del cliente, de solo lectura. Sin nota la tarjeta no existe: una tarjeta que
// dice «sin nota» ocupa el mismo lugar que una con contenido y no aporta nada.
import { FileCard } from './CustomerFileUi';

export function CustomerNotesCard({
    notes,
    isLoading,
}: {
    /** El texto guardado; `null` es un campo vacío leído, `undefined` es que todavía no llegó. */
    notes: string | null | undefined;
    isLoading: boolean;
}) {
    // Mientras la lectura vuela tampoco se pinta: todavía no se sabe si hay nota.
    if (isLoading || !notes) return null;

    return (
        <FileCard title="Notas operativas" grid={false}>
            <p className="whitespace-pre-wrap break-words text-[11.5px]">{notes}</p>
        </FileCard>
    );
}
